import { Fade } from "react-reveal";
import Typed from "typed.js";
import React, { useEffect, useRef } from "react";
function Loading() {
  const time = new Date().toLocaleTimeString();
  let date = new Date();
  let hrs = date.getHours();
  let greet;
  if (hrs < 12) greet = "Hey there,Good morning!";
  else if (hrs >= 12 && hrs <= 17) greet = "Hey there,Good afternoon!";
  else if (hrs >= 17 && hrs <= 24) greet = " Hey there,Good evening!";
  const el = useRef(null);
  const typed = useRef(null);
  useEffect(() => {
    const options = {
      strings: ["WELCOME TO MY WEBSITE!<br/> <br/>TEE~CODES"],
      typeSpeed: 70,
    };
    typed.current = new Typed(el.current, options);

    return () => {
      typed.current.destroy();
    };
  }, []);
  return (
    <div className="loader">
      <center>
        <Fade left duration={1000} className="greet">
          <div className="">
            <h6
              className="greets"
              style={{ color: "blue", fontWeight: "bolder", fontSize: "20px" }}
            >
              {greet}{" "}
            </h6>
            <p style={{ color: "blue", fontSize: "20px" }} className="time">
              {time}
            </p>
            <span style={{ color: "blue", fontSize: "20px" }}>
              {" "}
              <i
                className="fa fa-map-marker-alt"
                style={{ marginLeft: "", color: "crimson" }}
              ></i>
              Abeokuta,Ng.
            </span>
          </div>
        </Fade>
      </center>
      <div id="loading">
        <center>
          <span
            ref={el}
            style={{
              fontSize: "20px",
              textTransform: "capitalize",

              lineHeight: "1",
              letterSpacing: "1px",
              color: "white",
              fontWeight: "bolder",
            }}
            className="writeup"
          ></span>
        </center>
      </div>
    </div>
  );
}

export default Loading;
